import React, { Component, SyntheticEvent } from 'react';
import { Tag } from 'bloomer/lib/elements/Tag';
import { TextArea } from 'bloomer/lib/elements/Form/TextArea';
import styled from 'styled-components';

const LimitCounter = styled(Tag)`
  float: right;
`;

interface PropTypes {
  limit: number;
  id: string;
  name: string;
  onChange: (s: SyntheticEvent) => void;
  required?: boolean;
}

class LimitedCharTextArea extends Component<PropTypes> {
  state = {
    content: '',
  };

  handleChange = (e: SyntheticEvent) => {
    e.persist();
    const { limit, onChange } = this.props;
    const target = e.target as HTMLTextAreaElement;
    const content = target.value.substr(0, limit);
    target.value = content;
    this.setState({ content }, () => onChange(e));
  };

  render() {
    const { content } = this.state;
    const { limit, id, name, required } = this.props;

    return (
      <>
        <p>
          <LimitCounter isColor="black">
            Remaining Characters: {limit - content.length}
          </LimitCounter>
        </p>
        <TextArea
          onChange={this.handleChange}
          required={required}
          id={id}
          name={name}
          value={content}
        />
      </>
    );
  }
}

export default LimitedCharTextArea;
